export default __webpack_public_path__ + "static/media/disney image.00f5c3a6.webp";